import { memo } from 'react';
import { Box } from '@mantine/core';
import { RightSidebarPortal } from './RightSidebar';
import classes from './Layout.module.css';

export type LayoutProps = {
  leftSidebar?: React.ReactNode;
  children: React.ReactNode;
};

export const Layout = memo(({ leftSidebar, children }: LayoutProps) => (
  <Box className={classes.appLayout}>
    {leftSidebar}
    <Box className={classes.appLayoutMainContainer}>
      <Box className={classes.appLayoutMain}>{children}</Box>
    </Box>
    <RightSidebarPortal />
  </Box>
));
